import firebase from 'firebase';
import {data} from './data'

const firebaseConfig = {
    apiKey: "AIzaSyCeT9uo7ym2aHAaPxS22qdZDeCPeyel29Q",
    authDomain: "disneyplus-1234.firebaseapp.com",
    projectId: "disneyplus-1234",
    storageBucket: "disneyplus-1234.appspot.com",
    messagingSenderId: "617187368252",
    appId: "1:617187368252:web:d0ec59eb20baf796d5d239"
  };

  const firebaseApp = firebase.initializeApp(firebaseConfig)
  const db = firebaseApp.firestore();
  const auth = firebase.auth();
  const provider = new firebase.auth.GoogleAuthProvider();
  const storage = firebase.storage();

if(!db.collection("movies")) {
  data.forEach(function(obj) {
    db.collection("movies").add({
        backgroundImg: obj.backgroundImg,
        cardImg: obj.cardImg,
        description: obj.description,
        subtitle: obj.subtitle,
        title: obj.title,
        titleImg: obj.titleImg,
        type: obj.type
    }).then(function(docRef) {
        console.log("Document written with ID: ", docRef.id);
    })
    .catch(function(error) {
        console.error("Error adding document: ", error);
    });
});
}


  export {auth, provider, storage};
  export default db;